module.exports = __webpack_public_path__ + "static/media/avatar-padrao.eaa9c054.svg";